import type { SxStyles } from '@/ui/style/types';

/**
 * Gets custom sx classes for the map.
 *
 * @returns The sx classes object
 */
export const getSxClasses = (): SxStyles => ({
  mapContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    position: 'relative',

    '& .ol-viewport': {
      // Target OpenLayers viewport directly
      height: '100% !important',
      position: 'absolute',
      width: '100%',
      backgroundColor: 'white !important', // Keep viewport background white to avoid black backgound in fullscreen
    },

    '& .ol-viewport:active': {
      cursor: 'grabbing',
    },

    '& .ol-overviewmap.ol-custom-overviewmap': {
      bottom: 'auto',
      left: 'auto',
      right: '5px',
      top: '5px',
      margin: 5,
      order: 1,
      padding: 0,
      position: 'absolute',
      borderRadius: 4,

      '& .ol-overviewmap-map': {
        border: 'none',
        display: 'block !important',
        WebkitTransition: '300ms linear',
        MozTransition: '300ms linear',
        OTransition: '300ms linear',
        msTransition: '300ms linear',
        transition: '300ms linear',
      },
      '&.ol-uncollapsible': {
        bottom: 'auto',
        left: 'auto',
        right: 100,
        top: 100,
        margin: 5,
      },
      '&:not(.ol-collapsed)': {
        boxShadow: '0 1px 5px rgb(0 0 0 / 65%)',
        borderRadius: '4px',
        border: 'none',
      },
      '&:is(.ol-collapsed)': {
        boxShadow: '0 1px 5px rgb(0 0 0 / 65%)',
        borderRadius: 4,
        border: 'none',
      },
      '& button': {
        zIndex: 100,
        position: 'absolute',
        top: 0,
        right: 0,
        left: 'auto !important',
        bottom: 'auto !important',
        backgroundColor: '#cccccc',
      },
      '&::before': {
        content: '""',
        display: 'block',
        position: 'absolute',
        width: 0,
        height: 0,
        borderRadius: 2,
        zIndex: 100,
        right: 0,
        top: 0,
      },
      '& .ol-overviewmap-box': {
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
      },
      '& .ol-viewport': {
        borderRadius: '4px',
        '& .ol-layer': {
          backgroundColor: '#FFF',
        },
      },
    },
  },
  progressBar: {
    width: '100%',
    position: 'absolute',
    '> span': { height: '4px' },
  },
});
